import Vue from 'vue'
import App from './App.vue'
import VueAMap from 'vue-amap'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
// import {initMenu} from "@/utils/menus";
// import {getUserInfo} from "@/request/api";
import Clipboard from 'vue-clipboard2';
import VueNotification from "@kugatsu/vuenotification";

Vue.use(VueNotification, {
	timer: 10
});

Vue.use(ViewUI);
Vue.use(VueAMap)
Vue.use(ElementUI);
Vue.use(Clipboard);
Vue.config.productionTip = false;

VueAMap.initAMapApiLoader({
	key: 'ee1fb3f4ac55004219976c45e80ac6cc',
	plugin: ['AMap.Geolocation','AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MarkerClusterer','AMap.Geocoder'],
    v: '1.4.15',
    uiVersion: '1.0.11'
})

router.beforeEach((to, from, next)=>{
	if(window.sessionStorage.getItem("token")){
		console.log(window.sessionStorage.getItem("token"));
		// initMenu(router,store);
		// if(!window.sessionStorage.getItem("user")){
		// 	getUserInfo(window.sessionStorage.getItem("token")).then((res) => {
		// 		if (res) {
		// 			console.log(res);
		// 			window.sessionStorage.setItem('user', res.data.authos);
		// 			next();
		// 		}
		// 	})
		// }
		next();
	}else{
		console.log(to.path)
		if(to.path == '/login'||to.path =='/register'){
			next();
		}else{
			return next('/login')
		}
	}
})

new Vue({
	render: h => h(App),
	router,
	store
}).$mount('#app')
